import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "New Farm Config", -1)
const _hoisted_3 = { class: "flex items-end mb-5" }
const _hoisted_4 = { class: "nes-field mr-5 w-9/12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "mintA" }, "Reward A mint:", -1)
const _hoisted_6 = { class: "nes-select w-1/4" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex items-end mb-5" }
const _hoisted_10 = { class: "nes-field mr-5 w-9/12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "mintA" }, "Reward B mint:", -1)
const _hoisted_12 = { class: "nes-select w-1/4" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "nes-field mb-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "minStakingPeriodSec" }, "Min staking period (sec)", -1)
const _hoisted_17 = { class: "nes-field mb-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "cooldownPeriodSec" }, "Cooldown period (sec)", -1)
const _hoisted_19 = { class: "nes-field mb-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "unstakingFeeLamp" }, "Unstaking fee (lamports)", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "nes-btn is-primary mb-5",
  type: "submit"
}, "Start farm*", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "* this creates an associated Gem Bank automatically", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.initFarm && _ctx.initFarm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "mintA",
            class: "nes-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mintA) = $event))
          }, null, 512), [
            [_vModelText, _ctx.mintA]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeA) = $event))
          }, [
            _createElementVNode("option", {
              value: _ctx.RewardType.Variable
            }, "Variable", 8, _hoisted_7),
            _createElementVNode("option", {
              value: _ctx.RewardType.Fixed
            }, "Fixed", 8, _hoisted_8)
          ], 512), [
            [_vModelSelect, _ctx.typeA]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "mintB",
            class: "nes-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mintB) = $event))
          }, null, 512), [
            [_vModelText, _ctx.mintB]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.typeB) = $event))
          }, [
            _createElementVNode("option", {
              value: _ctx.RewardType.Variable
            }, "Variable", 8, _hoisted_13),
            _createElementVNode("option", {
              value: _ctx.RewardType.Fixed
            }, "Fixed", 8, _hoisted_14)
          ], 512), [
            [_vModelSelect, _ctx.typeB]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "minStakingPeriodSec",
          class: "nes-input",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.minStakingPeriodSec) = $event))
        }, null, 512), [
          [_vModelText, _ctx.minStakingPeriodSec]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "cooldownPeriodSec",
          class: "nes-input",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cooldownPeriodSec) = $event))
        }, null, 512), [
          [_vModelText, _ctx.cooldownPeriodSec]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "unstakingFeeLamp",
          class: "nes-input",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.unstakingFeeLamp) = $event))
        }, null, 512), [
          [_vModelText, _ctx.unstakingFeeLamp]
        ])
      ]),
      _hoisted_21,
      _hoisted_22
    ], 32)
  ]))
}